/**
 * `Select` (`shared/fields.tsx`) renders as `Autocomplete`, whose own
 * internal `.MuiAutocomplete-inputRoot`/`.MuiAutocomplete-input` styling is
 * more specific than the plain `MuiOutlinedInput` override and wins the
 * padding/height properties they both set — the same class of bug as the
 * legacy `.ctl` double border, just from MUI's own CSS this time, not the
 * legacy stylesheet. Forced to the app's one control height with
 * `!important` for the same reason.
 */
import type { Components, Theme } from '@mui/material/styles';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
	styleOverrides: {
		inputRoot: {
			height: 'var(--ctl-h) !important',
			paddingTop: '0 !important',
			paddingBottom: '0 !important',
			flexWrap: 'nowrap',
		},
		input: {
			height: 'var(--ctl-h) !important',
			padding: '0 !important',
			boxSizing: 'border-box',
		},
		endAdornment: {
			top: '50%',
			transform: 'translateY(-50%)',
		},
		/* One highlight, not two overlapping ones — keyboard focus and mouse
       hover use the same tint (`--surface-hover`); the currently-selected
       option gets its own accent tint, and a hovered-AND-selected option
       gets a third, slightly stronger accent tint rather than the two
       stacking into something muddier. */
		option: {
			'&.Mui-focused': {
				backgroundColor: 'var(--surface-hover)',
			},
			'&[aria-selected="true"]': {
				backgroundColor: 'var(--accent-surface)',
				color: 'var(--accent-deep)',
				fontWeight: 600,
			},
			'&[aria-selected="true"].Mui-focused': {
				backgroundColor: 'var(--accent-border)',
			},
		},
	},
};
